import { ConfigProvider, message } from "antd";
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Snowfall from "react-snowfall";
import "./App.css";
import Kalender from "./components/Kalender";

export type CalenderConfig = {
  designName?: string;
  backgroundColor?: string;
  logoName?: string;
  shoppingCenterName?: string;
  teilnahmebedingungenUrl?: string;
  teilnahmebedingungenEmail?: string;
  font?: string;
  currentDate?: string;
};

function App() {
  const [config, setConfig] = useState<CalenderConfig | null>(null);

  const loadConfig = async () => {
    const {
      success,
      error,
      config: c,
    } = (
      await axios.get(`${process.env.REACT_APP_SUB_DIR}api/public/config.php`)
    ).data;

    if (success) {
      setConfig({
        designName: c["design-name"] || null,
        backgroundColor: c["background-color"] || null,
        logoName: c["logo-name"] || null,
        shoppingCenterName: c["shopping-center-name"] || null,
        teilnahmebedingungenUrl: c["teilnahmebedingungen-url"] || null,
        teilnahmebedingungenEmail:
          c["teilnahmebedingungen-widerruf-email"] || null,
        font: c["font"] || null,
        currentDate: c["current-date"] || moment().format("YYYY-MM-DD"),
      });
    } else {
      message.error(`Fehler beim Laden des Kalenders: ${error}`);
    }
  };

  useEffect(() => {
    loadConfig();
  }, []);

  useEffect(() => {
    if (config && config.font) {
      document.body.classList.add(config!.font);
    } else {
      document.body.classList.add("font1");
    }
  }, [config]);

  return (
    <>
      <ConfigProvider
        theme={
          config && config.backgroundColor
            ? {
                token: {
                  colorLink: config!.backgroundColor,
                  colorLinkHover: config!.backgroundColor,
                  colorPrimary: config!.backgroundColor,
                },
              }
            : {}
        }
      >
        {config && config.backgroundColor ? (
          <Helmet>
            <style>{`body { background-color: ${config.backgroundColor}; }`}</style>
            <meta name="theme-color" content={config.backgroundColor}></meta>
          </Helmet>
        ) : (
          <Helmet>
            <meta name="theme-color" content="#ffffff"></meta>
          </Helmet>
        )}
        <Snowfall
          speed={[0.5, 1]}
          snowflakeCount={100}
          style={{ position: "fixed", zIndex: 1000 }}
        />
        {config && <Kalender config={config} />}
      </ConfigProvider>
    </>
  );
}

export default App;
